var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useQuestionnaire } from '@/store';
import { CONFIG_STYLE } from '@/types';
import { convertToCSS } from '@/utils';
import { Box } from '@chakra-ui/react';
export const BlockLayout = (_a) => {
    var _b, _c;
    var { children, layout } = _a, rest = __rest(_a, ["children", "layout"]);
    const { state: { questionnaire: { settings: { min_block_spacing = CONFIG_STYLE.PaddingType.small } = {} } = {} } } = useQuestionnaire();
    const finalLayout = Object.assign(Object.assign({}, layout), { padding: Object.assign(Object.assign({}, layout === null || layout === void 0 ? void 0 : layout.padding), { bottom: (_c = (_b = layout === null || layout === void 0 ? void 0 : layout.padding) === null || _b === void 0 ? void 0 : _b.bottom) !== null && _c !== void 0 ? _c : min_block_spacing }) });
    const styles = convertToCSS(finalLayout);
    return (_jsx(Box, Object.assign({ position: 'relative', sx: styles }, rest, { children: children })));
};
